'use client';
/** @jsxImportSource @emotion/react */

import type { DialogActionsProps as MuiDialogActionsProps } from '@mui/material/DialogActions';

import MuiDialogActions from '@mui/material/DialogActions';

type ExcludedMuiProps = '';

interface DialogActionsProps
  extends Omit<MuiDialogActionsProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { DialogActionsProps };
export const DialogActions: React.FC<DialogActionsProps> = MuiDialogActions;

DialogActions.displayName = 'DialogActions';
